import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { apiConnectorPost } from "../../utils/APIConnector";
import { endpoint } from "../../utils/APIRoutes";
import CustomTable from "../../Shared/CustomTable";
import CustomToPagination from "../../Shared/Pagination";
import { useFormik } from "formik";
import moment from "moment";
import { formatedDate, getFloatingValue } from "../../utils/utilityFun";

const Activation = () => {
  const [page, setPage] = useState(1);
  const client = useQueryClient();

  const fk = useFormik({
    initialValues: { search: "", count: 10, start_date: "", end_date: "" },
    enableReinitialize: true,
  });

  const { data, isLoading } = useQuery(
    ["get_actiavtion", fk.values.search, fk.values.start_date, fk.values.end_date, page],
    () =>
      apiConnectorPost(endpoint?.get_report_details, {
        search: fk.values.search,
        created_at: fk.values.start_date,
        updated_at: fk.values.end_date,
        page: page,
        count: "10",
        sub_label: "FUND WALLET",
        main_label: "IN",
      }),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError: (err) => console.error("Error fetching direct data:", err),
    }
  );

  const allData = data?.data?.result || [];

  const tablehead = ["S.No.", "Transaction", "Topup Date", "Topup Amount ($)", "Status"];

  const tablerow = allData?.data?.map((row, index) => [
    <span className="text-[#94A3B8]">{index + 1}</span>,
    <span className="text-[#CBD5E1] font-mono text-xs">{row?.tr07_trans_id}</span>,
    <span className="text-[#94A3B8]">{formatedDate(moment, row?.tr07_created_at)}</span>,
    <span className="text-white font-semibold">{getFloatingValue(row.tr07_tr_amount)}</span>,
    <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
      Success
    </span>,
  ]);

  return (
    <div
      className="min-h-screen relative"
      style={{ background: "linear-gradient(160deg, #060E1C 0%, #080F1C 50%, #0B1E36 100%)" }}
    >
      {/* Grid overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(37,99,235,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(37,99,235,0.03) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      {/* Decorative blobs */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(37,99,235,0.07) 0%, transparent 70%)" }}
      />
      <div
        className="absolute bottom-0 left-0 w-72 h-72 rounded-full blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(29,78,216,0.05) 0%, transparent 70%)" }}
      />

      <div className="relative z-10 p-4 sm:p-6">

        {/* ── Page Header ── */}
        <div className="mb-6">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="absolute inset-0 bg-[#2563EB]/30 rounded-xl blur-md" />
              <div className="relative w-10 h-10 rounded-xl bg-gradient-to-br from-[#2563EB]/20 to-[#1D4ED8]/20 border border-[#2563EB]/40 flex items-center justify-center">
                <svg className="w-5 h-5 text-[#22D3EE]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
            </div>
            <div>
              <h1 className="text-white font-bold text-lg tracking-wide leading-none">Fund Deposit History</h1>
              <p className="text-[#475569] text-xs mt-1">Track all your incoming deposit transactions</p>
            </div>
          </div>
          <div className="h-px bg-gradient-to-r from-transparent via-[#2563EB]/40 to-transparent mt-4" />
        </div>

        {/* ── Filter Card ── */}
        <div className="mb-5 rounded-2xl border border-[#1e3a5f]/50 bg-[#071526]/60 backdrop-blur-sm p-4">
          <div className="flex items-center gap-2 mb-3">
            <svg className="w-3.5 h-3.5 text-[#2563EB]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z" />
            </svg>
            <p className="text-[#475569] text-[10px] font-bold uppercase tracking-[0.2em]">Filter Records</p>
          </div>
          <div className="flex flex-wrap gap-3 items-end">
            <div className="flex flex-col gap-1.5">
              <label className="text-[#475569] text-[10px] uppercase tracking-widest font-semibold">From Date</label>
              <input
                type="date"
                name="start_date"
                value={fk.values.start_date}
                onChange={fk.handleChange}
                className="bg-[#060E1C] border border-[#1e3a5f]/60 rounded-xl py-2 px-3 text-white text-xs focus:outline-none focus:border-[#2563EB]/60 focus:ring-1 focus:ring-[#2563EB]/30 transition-all duration-200"
                style={{ colorScheme: "dark" }}
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-[#475569] text-[10px] uppercase tracking-widest font-semibold">To Date</label>
              <input
                type="date"
                name="end_date"
                value={fk.values.end_date}
                onChange={fk.handleChange}
                className="bg-[#060E1C] border border-[#1e3a5f]/60 rounded-xl py-2 px-3 text-white text-xs focus:outline-none focus:border-[#2563EB]/60 focus:ring-1 focus:ring-[#2563EB]/30 transition-all duration-200"
                style={{ colorScheme: "dark" }}
              />
            </div>
            <button
              onClick={() => { setPage(1); client.invalidateQueries(["get_actiavtion"]); }}
              className="flex items-center gap-2 py-2 px-5 rounded-xl text-white text-xs font-semibold transition-all duration-200 border border-[#2563EB]/40 hover:border-[#2563EB]/80 hover:shadow-[0_0_12px_rgba(37,99,235,0.25)]"
              style={{ background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)" }}
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              Search
            </button>
            <button
              onClick={() => { fk.handleReset(); setPage(1); }}
              className="flex items-center gap-2 py-2 px-5 rounded-xl text-[#64748B] hover:text-[#CBD5E1] text-xs font-semibold border border-[#1e3a5f]/50 hover:border-[#1e3a5f] bg-[#060E1C]/60 transition-all duration-200"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Clear
            </button>
          </div>
        </div>

        {/* ── Table Section ── */}
        <div className="rounded-2xl border border-[#1e3a5f]/50 bg-[#071526]/40 backdrop-blur-sm overflow-hidden">
          {/* Table header bar */}
          <div className="flex items-center justify-between px-4 py-3 border-b border-[#1e3a5f]/40">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#2563EB] animate-pulse" />
              <span className="text-[#475569] text-[11px] font-semibold uppercase tracking-widest">Deposit Records</span>
            </div>
            {!isLoading && allData?.data?.length > 0 && (
              <span className="text-[#2563EB] text-[11px] font-bold">
                {allData?.data?.length} entries
              </span>
            )}
          </div>

          <div className="p-3">
            <CustomTable tablehead={tablehead} tablerow={tablerow} isLoading={isLoading} />
          </div>

          {/* Pagination */}
          <div className="px-3 pb-3">
            <CustomToPagination page={page} setPage={setPage} data={allData} />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Activation;
